<template>
  <div 
    ref="containerRef" 
    class="h-full w-full max-w-[1440px] flex laptop:hidden flex-col items-center justify-center relative"
  >
    <MobileNavBarHeader
      :logo-props="logoProps"
      :is-menu-open="isMenuOpen"
      @menu-toggle="handleMenuToggle"
    />

    <MobileMenuDrawer
      :is-menu-open="isMenuOpen"
      :active-submenu="activeSubmenu"
      :menu-items="currentMenuItems"
      :logo-props="logoProps"
      @close="setIsMenuOpen(false)"
      @submenu-toggle="handleSubmenuToggle"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useMobileMenu } from '../hooks/useMobileMenu'
import { getDefaultMobileMenuItems } from '../data/mobileMenuItems'
import type { MobileNavBarProps } from '../types/mobileNavigation'
import MobileNavBarHeader from './MobileNavBarHeader.vue'
import MobileMenuDrawer from './MobileMenuDrawer.vue'

interface Props {
  menuItems?: MobileNavBarProps['menuItems']
  logoProps?: MobileNavBarProps['logoProps']
}

const props = withDefaults(defineProps<Props>(), {
  menuItems: undefined,
  logoProps: undefined
})

const {
  isMenuOpen,
  activeSubmenu,
  containerRef,
  handleMenuToggle,
  handleSubmenuToggle: originalHandleSubmenuToggle,
  setIsMenuOpen
} = useMobileMenu()

const handleSubmenuToggle = (menuKey: string, hasSubmenu: boolean) => {
  console.log('🔄 [NavBarContentMobile] handleSubmenuToggle received:', { menuKey, hasSubmenu })
  originalHandleSubmenuToggle(menuKey, hasSubmenu)
}

const currentMenuItems = computed(() => 
  props.menuItems && props.menuItems.length > 0 
    ? props.menuItems 
    : getDefaultMobileMenuItems()
)
</script>

<style scoped>
/* Styles additionnels si nécessaire */
</style>

